import { cn } from '@/utils/cn';
interface Props {
  isBlack?: boolean;
}
export default function Skeleton({
  isBlack = false
}: Props) {
  return <div className={cn('homepage-container absolute left-0 top-0 h-[200px] w-full lg:h-[330px]', isBlack ? 'bg-blackFriday' : 'bg-white')} data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex h-full w-full items-center justify-between'>
                <div className={cn('h-full w-[9.5%] animate-pulse rounded-l', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                <div className={cn('h-full w-[77%] animate-pulse rounded', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                <div className={cn('h-full w-[9.5%] animate-pulse rounded-r', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
            </div>
        </div>;
}